import { Component, FormEvent } from 'react';
import { ChangeEvent } from 'react-autosuggest';

import {
  InputPrefixVariant,
  InputStyleVariant,
} from 'components/Input/Input.styled';
import { LocationInput } from 'components/LocationInput';

type Props = {
  placeholder?: string;
  locationText: string | null | undefined;
  onChange: (
    arg0: SearchLocation | null | undefined,
    arg1: boolean | null | undefined
  ) => void;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onBlur?: (...args: Array<any>) => any;
  showClearButton?: boolean;
  className?: string;
  disabled?: boolean;
  includeFull?: boolean;
  validateOnBlur?: boolean;
  showLocationIcon?: boolean;
  prefixVariant?: InputPrefixVariant;
  styleVariant?: InputStyleVariant;
};
type State = {
  locationInputValue: string;
  prevPropsLocationText: string | null | undefined;
};

class LocationInputContainer extends Component<Props, State> {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/static-property-placement
  static defaultProps = {
    showClearButton: false,
  };

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/state-in-constructor
  state = {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    locationInputValue: this.props.locationText || '',
    // eslint-disable-next-line react/destructuring-assignment
    prevPropsLocationText: this.props.locationText,
  };

  static getDerivedStateFromProps(props: Props, state: State) {
    // if the search location changes in the Redux store, update the
    // search input with the new value
    if (props.locationText !== state.prevPropsLocationText) {
      return {
        locationInputValue: props.locationText || '',
        prevPropsLocationText: props.locationText,
      };
    }

    return null;
  }

  clearLocation = (shouldEnqueueSearch?: boolean) => {
    this.setState({
      locationInputValue: '',
    });
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    this.props.onChange(undefined, shouldEnqueueSearch);
  };

  onLocationInputValueChange = (
    e: FormEvent<unknown>,
    { newValue }: ChangeEvent
  ) => {
    if (newValue === '') {
      this.clearLocation(false);
    }

    this.setState({
      locationInputValue: newValue,
    });
  };

  render() {
    const {
      locationText,
      onChange,
      className,
      onBlur,
      prefixVariant,
      styleVariant,
      ...inputProps
    } = this.props;
    return (
      <LocationInput
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...inputProps}
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        locationInputValue={this.state.locationInputValue}
        // @ts-expect-error TS(2322): Type 'boolean | undefined' is not assignable to ty... Remove this comment to see the full error message
        showClearButton={
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          this.props.showClearButton && Boolean(this.state.locationInputValue)
        }
        clearLocation={() => this.clearLocation(false)}
        onLocationChange={onChange}
        onLocationInputValueChange={this.onLocationInputValueChange}
        className={className}
        hasRemoteOptions
        showLocationIcon
        prefixVariant={prefixVariant}
        styleVariant={styleVariant}
      />
    );
  }
}

// eslint-disable-next-line import/no-default-export
export default LocationInputContainer;
